export enum Routes {
  Root = '/',
  Imprint = '/imprint',
  Dsgvo = '/dsgvo',
  Map = '/map',
  Analysis = '/analysis'
}
